module.exports = __webpack_public_path__ + "static/coreFeature1-9e8a30b472f0bdc0e589dd84e2e03569.png";